import { Component, OnInit } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { InventoryService } from '../../../services/inventory.service';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-inventory-status-lookup',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './inventory-status-lookup.component.html',
  styleUrl: './inventory-status-lookup.component.scss'
})
export class InventoryStatusLookupComponent implements OnInit{

  constructor(private inventoryService:InventoryService, private config: DynamicDialogConfig){};

  inventory: any[] = [];
  productCode: any;
  unitLabel: string = ''; 
  loader: boolean = false; 

  ngOnInit(): void {
    let ProductCode = this.config.data?.ProductCode;
    this.productCode = ProductCode;
    this.getInventoryStatus(ProductCode)
    this.getUnitLabel(); 
  }

  getInventoryStatus(productCode:string) {
    this.inventoryService.getInventoryStatus(productCode).subscribe({
      next: (data: any) => {
        if(data.success == false){
          console.log(data);
        }else{
          this.inventory =  data;
          // console.log(data);
        }
      },
      error: error => {
        console.log(error);
      }
    })
  }

  refreshData(): void {
    if (this.productCode) {
      this.getInventoryStatus(this.productCode);
    }
  }

  getUnitLabel(): void {
  this.loader = true;
  const appKey = 'unitNameLabel';

  this.inventoryService.getUnitByAppKey(appKey).subscribe({
    next: (response: any) => {
      this.loader = false;
      if (response?.appKeycode === appKey) {
        this.unitLabel = response?.data;
      } else {
        this.unitLabel = 'Unit';
      }
    },
    error: error => {
      console.error('Error fetching Unit Label:', error);
      this.unitLabel = 'Unit';
      this.loader = false;
    }
  });
}

}
